import TableCellLegendeSemaines from '../../Components/Includes/Table/TableCellLegendeSemaines'

export const properties = {
  type: {
    id: "semaines",
    groupe: "legendes"
  },
  sort: {
    by: "",
    order: ""
  },
  columns: [
    {
      id: "nom",
      padding: true,
      component: TableCellLegendeSemaines
    }
  ]
}
